// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"Terms_filterContainer__nADbg"};